import { TableCell, TableRow, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useState } from "react";
import TableActions from "src/common/TableActions";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import { useApiMutation } from "src/hooks/useApiMutation";
import type { IVisitorMoneyReceipt } from "../type/visitorType";

type IProps = {
	serial: number;
	paginationSkip: number;
	moneyReceipt: IVisitorMoneyReceipt;
};

const VisitorMoneyReceiptTableRow = ({
	serial,
	paginationSkip,
	moneyReceipt,
}: IProps) => {
	const [open, setOpen] = useState(false);
	const handleClose = () => setOpen(false);
	const {
		mutate: deleteMoneyReceipt,
		isPending,
		isSuccess,
	} = useApiMutation<void, void>({
		method: "DELETE",
		endPoint: `/api/admin/visitor/money-receipt/${moneyReceipt.id}`,
		invalidateQueries: ["money-receipt"],
	});
	return (
		<>
			<TableRow hover>
				<TableCell>{serial + Number(paginationSkip)}</TableCell>
				<TableCell>
					<Typography variant='body1' color='text.primary' noWrap>
						{dayjs(moneyReceipt.payment_date).format("DD-MM-YYYY")}
					</Typography>
				</TableCell>
				<TableCell>{moneyReceipt.money_receipt_no}</TableCell>
				<TableCell>{moneyReceipt.payment_method || "N/A"}</TableCell>
				<TableCell>
					{parseFloat(moneyReceipt.paid_amount)?.toFixed(2)}
				</TableCell>

				<TableActions
					showView
					viewLink={`/visitor/money-receipt/details/${moneyReceipt.id}`}
					showDelete
					handleDeleteFun={() => deleteMoneyReceipt()}
				/>
			</TableRow>

			<ModalsWrapper
				showModal={open}
				setShowModal={setOpen}
				modalData={{ title: "Update Money Receipt" }}
			>
				<>
					{/* <EditMoneyReceipt
                        id={moneyReceipt.id}
                        handleClose={handleClose}
                    /> */}
				</>
			</ModalsWrapper>
		</>
	);
};

export default VisitorMoneyReceiptTableRow;
